// extracted by mini-css-extract-plugin
export default {"layout":"Layout_layout__zdiX1","content":"Layout_content__2WZfY"};